import axios from "axios";

const baseURL = "https://webview-api-prod.armsolutions.com/api/";
const baseURLDev = "https://localhost:44316/api/";

export const instance = axios.create({
  baseURL: baseURL,
  timeout: 600000,
  headers: {
    "Access-Control-Allow-Origin": "*",
  },
});
